export enum NavLink {
  ALARMS = "/alarms",
  CONTACTS = "/contacts",
  CONTACT_GROUPS = "/contact-groups",
  DEVICES = "/devices",
  SCENARIOS = "/scenarios",
  SIGNIN = "/signin",
  START = "/",
}
